import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

const LISTS = [
  { key: "faculties", label: "Facultés" },
  { key: "departments", label: "Départements" },
  { key: "promotions", label: "Promotions" },
  { key: "disciplines", label: "Disciplines" },
];

function ListEditor({ name, label }) {
  const [items, setItems] = useState([]);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  const load = () => api.get(`/lists/${name}`).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [name]);

  const add = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post(`/lists/${name}`, { name: value });
      setValue("");
      load();
    } catch (err) { setError(formatApiError(err)); }
  };

  const del = async (id) => {
    if (!window.confirm("Supprimer cet élément ?")) return;
    await api.delete(`/lists/${name}/${id}`);
    load();
  };

  return (
    <div className="paper-card p-6" data-testid={`list-${name}`}>
      <div className="flex items-center justify-between">
        <h3 className="font-display font-semibold text-unisic-blue">{label}</h3>
        <span className="text-xs text-slate-500">{items.length} entrées</span>
      </div>
      <form onSubmit={add} className="mt-4 flex gap-2">
        <input value={value} onChange={(e) => setValue(e.target.value)} placeholder={`Ajouter à ${label}`} className="flex-1 border border-slate-300 px-3 py-2 rounded-sm text-sm" data-testid={`input-${name}`} />
        <button type="submit" className="btn-primary text-sm" data-testid={`btn-add-${name}`}><Plus className="w-4 h-4" /></button>
      </form>
      {error && <div className="mt-2 text-xs text-unisic-red">{error}</div>}
      <ul className="mt-4 space-y-1 max-h-64 overflow-y-auto">
        {items.map((it) => (
          <li key={it.id} className="flex items-center justify-between px-3 py-2 hover:bg-slate-50 rounded-sm text-sm" data-testid={`item-${name}-${it.id}`}>
            <span>{it.name}</span>
            <button onClick={() => del(it.id)} className="text-slate-400 hover:text-unisic-red">
              <Trash2 className="w-3.5 h-3.5" />
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default function AdminLists() {
  return (
    <div data-testid="admin-lists">
      <div className="eyebrow eyebrow-dark">Configuration</div>
      <h1 className="mt-2 text-3xl font-bold text-unisic-blue">Listes de référence</h1>
      <p className="mt-2 text-slate-600 text-sm">Facultés, départements, promotions et disciplines utilisés dans les formulaires.</p>
      <span className="divider-gold mt-3" />
      <div className="mt-8 grid gap-6 md:grid-cols-2">
        {LISTS.map((l) => <ListEditor key={l.key} name={l.key} label={l.label} />)}
      </div>
    </div>
  );
}
